var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "打款平台", prop: "payPlatForm" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择打款平台" },
                          model: {
                            value: _vm.ruleForm.payPlatForm,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "payPlatForm", $$v)
                            },
                            expression: "ruleForm.payPlatForm",
                          },
                        },
                        _vm._l(
                          _vm.promotionDict.tax_pay_plat_form,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.dictValue,
                                value: item.dictCode,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "打款公司", prop: "payCompany" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择打款公司" },
                          model: {
                            value: _vm.ruleForm.payCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "payCompany", $$v)
                            },
                            expression: "ruleForm.payCompany",
                          },
                        },
                        _vm._l(
                          _vm.promotionDict.tax_pay_company,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.dictValue,
                                value: item.dictCode,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "打款凭证命名规则", prop: "ruleCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择打款凭证命名规则" },
                          model: {
                            value: _vm.ruleForm.ruleCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "ruleCode", $$v)
                            },
                            expression: "ruleForm.ruleCode",
                          },
                        },
                        _vm._l(
                          _vm.promotionDict.tax_rule_type,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.dictValue,
                                value: item.dictCode,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "流水单号", prop: "taxSeqNo" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ruleForm.taxSeqNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "taxSeqNo", $$v)
                          },
                          expression: "ruleForm.taxSeqNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "upload-section" },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    action: "1",
                    headers: {
                      loginUserToken: _vm.Storage.l.get("TokenKey"),
                    },
                    "show-file-list": true,
                    "on-exceed": _vm.handleExceed,
                    "before-upload": _vm.beforeUpload,
                    "on-preview": _vm.handlePreview,
                    "on-change": _vm.handleChange,
                    "on-remove": _vm.handleRemove,
                    "before-remove": _vm.beforeRemove,
                    "on-success": _vm.handleSuccess,
                    limit: 10,
                    accept: _vm.accept,
                    "file-list": _vm.fileList,
                    "auto-upload": false,
                    multiple: true,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v(" 仅支持ZIP文件，单文件不超过2GB，支持大文件上传 ")]
                  ),
                ]
              ),
              _vm.uploadProgress.visible
                ? _c(
                    "div",
                    { staticClass: "upload-progress" },
                    [
                      _c(
                        "div",
                        { staticClass: "progress-header" },
                        [
                          _c("span", [_vm._v("上传进度")]),
                          !_vm.uploadProgress.isPaused &&
                          _vm.uploadProgress.uploading
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.pauseUpload },
                                },
                                [_vm._v(" 暂停 ")]
                              )
                            : _vm._e(),
                          _vm.uploadProgress.isPaused &&
                          _vm.uploadProgress.uploading
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.resumeUpload },
                                },
                                [_vm._v(" 继续 ")]
                              )
                            : _vm._e(),
                          _vm.uploadProgress.uploading
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.cancelUpload },
                                },
                                [_vm._v(" 取消 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._l(_vm.uploadProgress.files, function (file) {
                        return _c(
                          "div",
                          { key: file.uid, staticClass: "file-progress" },
                          [
                            _c("div", { staticClass: "file-info" }, [
                              _c("span", { staticClass: "file-name" }, [
                                _vm._v(_vm._s(file.name)),
                              ]),
                              _c("span", { staticClass: "file-status" }, [
                                _vm._v(_vm._s(_vm.getStatusText(file))),
                              ]),
                              file.useChunk
                                ? _c("span", { staticClass: "upload-mode" }, [
                                    _vm._v("(分片上传)"),
                                  ])
                                : _c("span", { staticClass: "upload-mode" }, [
                                    _vm._v("(直接上传)"),
                                  ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "progress-details" },
                              [
                                _c("el-progress", {
                                  attrs: {
                                    percentage: file.percentage,
                                    status: _vm.getProgressStatus(file),
                                    "show-text": false,
                                  },
                                }),
                                _c("div", { staticClass: "progress-text" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatSize(file.uploadedSize)
                                      ) +
                                        " / " +
                                        _vm._s(_vm.formatSize(file.totalSize))
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(_vm._s(file.percentage) + "%"),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            file.speed
                              ? _c("div", { staticClass: "upload-speed" }, [
                                  _vm._v(
                                    " 速度: " +
                                      _vm._s(_vm.formatSpeed(file.speed)) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", {
            staticClass: "wsMessageBox",
            domProps: { innerHTML: _vm._s(_vm.propsObj.exportMessage) },
          }),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              !_vm.propsObj.isExport && _vm.propsObj.code !== "view_prograss"
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.uploadLoading,
                        size: "small",
                        disabled: !_vm.hasValidFiles,
                      },
                      on: { click: _vm.startUploadProcess },
                    },
                    [_vm._v(" 开始上传 ")]
                  )
                : _vm._e(),
              !_vm.propsObj.isExport &&
              _vm.propsObj.code === "view_prograss" &&
              _vm.propsObj.row.filePathAsImportFail
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.download_originfile("fail")
                        },
                      },
                    },
                    [_vm._v(" 下载失败文件 ")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    size: "small",
                    icon: "el-icon-close",
                  },
                  on: { click: _vm.dialog_btnClose },
                },
                [_vm._v(" 关闭 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }